var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-form-preview',{attrs:{"fields":_vm.form.fields,"buttons":_vm.form.buttons,"template":_vm.temp},scopedSlots:_vm._u([{key:"form_preview",fn:function(ref){
var data = ref.data;
return [_vm._v("\n     "+_vm._s(data)+"\n   ")]}},{key:"empty_state",fn:function(){return [_vm._v("pls fill the form")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }